import React, { Component } from 'react';
import InterviewDashboardView from './InterviewDashboardView';
import { url } from '../../../Server/url/GlobalUrl'
import moment from 'moment'



class InterviewDashboardComponent extends Component {
      state={
                interviews_detail: [],
                modal_show: false,
                authResponse: '',
                color : 'red',
                id : '',
            }
 componentDidMount() {
    fetch((url + "/api/v1/user/user-verification-status/?type=Schedule Interview"), {
                method: 'GET'
                })
              .then(res => res.json())
              .then(
		        (result) => {
		            console.log('result',result)
		          if (result.length > 0){
                    this.setState({'id': result[0].id})
		          fetch((url + "/api/v1/user/submit-details/?is_applicant=true&verification_status=" + result[0].id), {
                method: 'GET',
                 headers: {
                   'Accept': 'application/json',
                   'Content-Type': 'application/json',
                },
                })
              .then(res => res.json())
              .then(
		        (result) => {
		            console.log('result',result)

		            if (result){
		             var i;
                        for (i of result) {
                            var day = moment(result.interview_date).format("MMMM DD, YYYY")
                            i['interview_date'] = day
                            console.log('day',day)

                        }
                        console.log('check status',result)

                     }
                     return result
		        })
		        .then(
                    (res) => {
                        console.log('check status1',res)
                        this.setState({
                            interviews_detail : res
                        })
                    })
		          }
		        },
		        (error) => {
		          console.log('error',error)
				})


		 }
     hideCustomModal = () => {
        this.setState({ modal_show: false })
    }

    showCustomModal = () => {
        this.setState({ modal_show: true })
    }
    acceptinginterview = (id) => {
        console.log('id',id)
		let data = {'is_interview_accepted':true}
		fetch((url + "/api/v1/user/submit-details/" + id + '/'), {
                method: 'PUT',
                 headers: {
                   'Accept': 'application/json',
                   'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
                })
              .then(res => res.json())
              .then(
		        (result) => {
		           if (result){
		                console.log('result',result)
		                this.showCustomModal()
		                this.setState({authResponse:'Interview added Successfully'})
		                this.setState({color:'green'})
		                 fetch((url + "/api/v1/user/submit-details/?verification_status=" + this.state.id), {
                            method: 'GET',
                             headers: {
                               'Accept': 'application/json',
                              'Content-Type': 'application/json',
                            },
                            })
                          .then(res => res.json())
                          .then(
                            (result) => {
                                console.log('result',result)
                                this.setState({
                                    interviews_detail : result
                                })
                            })
		           }
		        })

    }
    handledelete = (id) => {
        console.log('hello all deleted',id)
         fetch((url + "/api/v1/user/submit-details/" + id + '/'), {
                method: 'DELETE',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                })
                .then((response) => {
            console.log("response", response)
            if (response['status'] === 201 || response['status'] === 200 || response['status'] === 204) {
                this.showCustomModal()
				this.setState({authResponse:'Deleted Successfully'})
                fetch((url + "/api/v1/user/submit-details/?verification_status=2"), {
                method: 'GET',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                })
              .then(res => res.json())
              .then(
		        (result) => {
		            console.log('result',result)
		            this.setState({
		                interviews_detail : result
		            })
		        })
            } else if (response['status'] === 400) {
                this.showCustomModal()
				this.setState({authResponse:'Something went wrong please try again'})
            }
        })
    }
    handlepreview = (interview_status,id) => {
        console.log(interview_status);
        localStorage.removeItem('from_applicant')
        localStorage.setItem('cv-id',id)
        localStorage.setItem('actual-id',id)
        localStorage.setItem('cv-id-preview',id)
        if(interview_status === "Schedule Interview"){
            window.location.replace('/registrations/form4')
        }
        else{
            window.location.replace('/registration/cv-summary')
        }
    }

 render() {
        return (
            <InterviewDashboardView
                  interviews_detail = {this.state.interviews_detail}
                  handledelete = {this.handledelete}
                  authResponse={this.state.authResponse}
                  modal_show={this.state.modal_show}
                  hideCustomModal={this.hideCustomModal}
                  handlepreview={this.handlepreview}
                  acceptinginterview={this.acceptinginterview}
                  color = {this.state.color}

            />
        )
    }

}

export default InterviewDashboardComponent;